import { render, staticRenderFns } from "./analyze3D.vue?vue&type=template&id=70db681e&scoped=true"
import script from "./analyze3D.vue?vue&type=script&lang=js"
export * from "./analyze3D.vue?vue&type=script&lang=js"
import style0 from "./analyze3D.vue?vue&type=style&index=0&id=70db681e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70db681e",
  null
  
)

export default component.exports